import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export default function UserMentionSelecting(
    {
        filteredMembers,
        focusedMember,
        tagMember
    }: { 
        filteredMembers: { profilePicture: string; username: string }[]; 
        focusedMember: number; 
        tagMember: (member: { profilePicture: string; username: string }) => void 
    }
) {

    return (
        <>
            {filteredMembers?.length !== 0 && (
                <div className="absolute bottom-14 rounded-lg cursor-pointer p-1 w-full bg-brand-dark">
                    <div className="flex items-start space-x-2 rounded-t-lg w-full">
                        <div className="flex flex-col items-start p-2 gap-2 rounded-t-lg w-full max-h-96 overflow-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                            {filteredMembers?.map((member: any, index: number) => (
                                <div key={index} className={`font-semibold text-gray-300 hover:bg-brand-darkest w-full p-2 rounded-lg ${focusedMember === index ? "bg-brand-darkest" : ""
                                    } ${index === filteredMembers.length - 1 ? "rounded-b-lg" : ""
                                    }`} onClick={() => tagMember(member)} >
                                    <div className="flex items-center rounded-t-lg">
                                        <div className="flex items-center space-x-2 rounded-t-lg">
                                            <Avatar className=" h-6 w-6 rounded-full bg-brand-back">
                                                <AvatarImage className="rounded-full" src={member?.profilePicture} loading="lazy" />
                                                <AvatarFallback className="text-xs">{member?.username[0]}</AvatarFallback>
                                            </Avatar>
                                            <span className="font-semibold text-gray-300">{member.username}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}